import { useState } from "react";
import { useNavigate } from "@tanstack/react-router";

import { Button } from "@monorepo-apps/ui/src/components/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@monorepo-apps/ui/src/components/dialog";

import { useUpsertCandidate } from "@/application/use-cases/candidates/use-candidates.queries";
import {
  CandidateFormBody,
  type CandidateFormValues,
} from "@/presentation/components/candidates/candidate-form-body";

interface CreateCandidateDialogProps {
  open: boolean;
  onClose: () => void;
}

export function CreateCandidateDialog({ open, onClose }: CreateCandidateDialogProps) {
  const [values, setValues] = useState<CandidateFormValues | null>(null);
  const upsert = useUpsertCandidate();
  const navigate = useNavigate();

  const handleSave = () => {
    if (!values || !values.slug || !values.name) return;
    upsert.mutate(values, {
      onSuccess: (row) => {
        onClose();
        void navigate({ to: "/candidates/$slug", params: { slug: row.slug } });
      },
    });
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="!max-w-2xl">
        <DialogHeader>
          <DialogTitle>New candidate architecture</DialogTitle>
        </DialogHeader>
        <CandidateFormBody initial={null} onChange={setValues} />
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            disabled={upsert.isPending || !values?.slug || !values?.name}
          >
            {upsert.isPending ? "Creating…" : "Create candidate"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
